var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.485 3.3335H13.5167C8.45 3.3335 5.5 6.30016 5.5 11.3835V28.6002C5.5 33.7668 8.45 36.6668 13.5167 36.6668H27.485C32.6333 36.6668 35.5 33.7668 35.5 28.6002V11.3835C35.5 6.30016 32.6333 3.3335 27.485 3.3335Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9666 11.0835V11.1002C13.2483 11.1002 12.6666 11.6835 12.6666 12.4002C12.6666 13.1168 13.2483 13.7002 13.9666 13.7002H18.9483C19.6666 13.7002 20.2499 13.1168 20.2499 12.3818C20.2499 11.6668 19.6666 11.0835 18.9483 11.0835H13.9666ZM27.0333 21.2335H13.9666C13.2483 21.2335 12.6666 20.6502 12.6666 19.9335C12.6666 19.2168 13.2483 18.6318 13.9666 18.6318H27.0333C27.7499 18.6318 28.3333 19.2168 28.3333 19.9335C28.3333 20.6502 27.7499 21.2335 27.0333 21.2335ZM27.0333 28.8502H13.9666C13.4666 28.9168 12.9833 28.6668 12.7166 28.2502C12.4499 27.8168 12.4499 27.2668 12.7166 26.8502C12.9833 26.4168 13.4666 26.1835 13.9666 26.2335H27.0333C27.6983 26.3002 28.1999 26.8668 28.1999 27.5502C28.1999 28.2152 27.6983 28.7835 27.0333 28.8502Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.751e2b1631a464af2cefe606e414850f.svg";
export { ForwardRef as ReactComponent };